(function () {
  'use strict';
  if (window.innerWidth >= 750) return;

  var S = document.createElement('style');
  S.textContent = [
    'product-card{position:relative!important}',
    '.bv-btn{position:absolute;top:9px;right:9px;width:34px;height:34px;background:rgba(255,255,255,.92);border:0.5px solid rgba(0,0,0,.1);border-radius:50%;display:flex;align-items:center;justify-content:center;z-index:50;box-shadow:0 2px 8px rgba(0,0,0,.12);padding:0;cursor:pointer;touch-action:manipulation;}',
    '#bv-bd{position:fixed;inset:0;z-index:10100;background:rgba(0,0,0,.5);display:none;}',
    '#bv-bd.on{display:block;}',
    '#bv-sh{position:fixed;bottom:0;left:0;right:0;z-index:10101;background:#fff;border-radius:16px 16px 0 0;transform:translateY(100%);transition:transform .35s cubic-bezier(.25,.46,.45,.94);max-height:90dvh;overflow-y:auto;padding-bottom:calc(68px + env(safe-area-inset-bottom,0px) + 24px);}',
    '#bv-sh.on{transform:translateY(0);}',
    '#bv-hdl{width:36px;height:4px;background:rgba(0,0,0,.1);border-radius:2px;margin:14px auto 0;}',
    '#bv-body{padding:16px 20px 0;}',
    '#bv-top{display:flex;gap:14px;margin-bottom:20px;align-items:flex-start;}',
    '#bv-img{width:90px;height:114px;object-fit:cover;object-position:top center;border-radius:8px;flex-shrink:0;background:#f0f0f0;}',
    '#bv-meta{flex:1;min-width:0;padding-top:2px;}',
    '#bv-vendor{font-size:8px;font-weight:700;text-transform:uppercase;letter-spacing:2.5px;color:rgba(0,0,0,.3);margin-bottom:5px;}',
    '#bv-title{font-size:13px;font-weight:400;line-height:1.3;margin-bottom:8px;color:#000;}',
    '#bv-price{font-size:15px;font-weight:500;color:#000;}',
    '.bv-div{height:0.5px;background:rgba(0,0,0,.08);margin:16px 0;}',
    '#bv-opts{margin-bottom:4px;}',
    '.bv-og{margin-bottom:16px;}',
    '.bv-ol{font-size:8px;font-weight:700;text-transform:uppercase;letter-spacing:2px;color:rgba(0,0,0,.38);margin-bottom:8px;}',
    '.bv-or{display:flex;flex-wrap:wrap;gap:6px;}',
    '.bv-op{padding:7px 14px;border:0.5px solid rgba(0,0,0,.2);background:#fff;font-size:11px;font-weight:500;border-radius:4px;color:#000;cursor:pointer;touch-action:manipulation;-webkit-tap-highlight-color:transparent;}',
    '.bv-op.on{background:#000;color:#fff;border-color:#000;}',
    '.bv-op.na{opacity:.3;text-decoration:line-through;pointer-events:none;}',
    '#bv-qty-row{display:flex;align-items:center;justify-content:space-between;margin-bottom:16px;}',
    '#bv-qty-lbl{font-size:8px;font-weight:700;text-transform:uppercase;letter-spacing:2px;color:rgba(0,0,0,.38);}',
    '#bv-qty-ctrl{display:flex;align-items:center;gap:0;border:0.5px solid rgba(0,0,0,.2);border-radius:4px;overflow:hidden;}',
    '.bv-qb{width:34px;height:34px;background:#fff;border:none;font-size:16px;font-weight:400;color:#000;cursor:pointer;touch-action:manipulation;display:flex;align-items:center;justify-content:center;-webkit-tap-highlight-color:transparent;}',
    '.bv-qb:active{background:rgba(0,0,0,.05);}',
    '#bv-qn{width:34px;text-align:center;font-size:13px;font-weight:500;color:#000;border:none;border-left:0.5px solid rgba(0,0,0,.12);border-right:0.5px solid rgba(0,0,0,.12);background:#fff;pointer-events:none;}',
    '#bv-atc{width:100%;height:46px;background:#000;color:#fff;border:none;border-radius:4px;font-size:10px;font-weight:700;letter-spacing:3px;text-transform:uppercase;cursor:pointer;margin-bottom:10px;touch-action:manipulation;display:block;}',
    '#bv-atc:disabled{opacity:.38;cursor:default;}',
    '#bv-lnk{display:block;text-align:center;font-size:10px;color:rgba(0,0,0,.32);text-decoration:none;letter-spacing:1px;padding:4px 0;}',
    '.bv-sw-h{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) scale(0);font-size:52px;color:#ff2d55;z-index:20;pointer-events:none;animation:bvH .85s ease forwards;}',
    '@keyframes bvH{0%{transform:translate(-50%,-50%) scale(0);opacity:1}45%{transform:translate(-50%,-50%) scale(1.3)}100%{transform:translate(-50%,-70%) scale(1);opacity:0}}',
    '.bv-sw-f{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);background:rgba(0,0,0,.82);color:#fff;font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:2.5px;padding:8px 16px;border-radius:20px;z-index:20;pointer-events:none;white-space:nowrap;animation:bvF .6s ease forwards;}',
    '@keyframes bvF{0%{opacity:0}20%{opacity:1}75%{opacity:1}100%{opacity:0}}',
    /* FIX #1: nasconde la bottom nav quando il quickshop è aperto */
    'body.bv-qs-open #bv-bn{display:none!important;}'
  ].join('');
  document.head.appendChild(S);

  var built = false;
  var state = { variantId: null, qty: 1 };

  function build() {
    if (built) return;
    built = true;
    var bd = document.createElement('div'); bd.id = 'bv-bd';
    bd.addEventListener('click', closeSheet);
    document.body.appendChild(bd);
    var sh = document.createElement('div'); sh.id = 'bv-sh';
    var hdl = document.createElement('div'); hdl.id = 'bv-hdl'; sh.appendChild(hdl);
    var body = document.createElement('div'); body.id = 'bv-body';
    var top = document.createElement('div'); top.id = 'bv-top';
    var img = document.createElement('img'); img.id = 'bv-img'; img.alt = ''; top.appendChild(img);
    var meta = document.createElement('div'); meta.id = 'bv-meta';
    ['bv-vendor','bv-title','bv-price'].forEach(function(id){
      var d = document.createElement('div'); d.id = id; meta.appendChild(d);
    });
    top.appendChild(meta); body.appendChild(top);
    var d1 = document.createElement('div'); d1.className = 'bv-div'; body.appendChild(d1);
    var opts = document.createElement('div'); opts.id = 'bv-opts'; body.appendChild(opts);
    var qrow = document.createElement('div'); qrow.id = 'bv-qty-row';
    var qlbl = document.createElement('div'); qlbl.id = 'bv-qty-lbl'; qlbl.textContent = 'Quantità';
    var qctrl = document.createElement('div'); qctrl.id = 'bv-qty-ctrl';
    var qm = document.createElement('button'); qm.type='button'; qm.className='bv-qb'; qm.textContent='−';
    var qn = document.createElement('div'); qn.id='bv-qn'; qn.textContent='1';
    var qp = document.createElement('button'); qp.type='button'; qp.className='bv-qb'; qp.textContent='+';
    qm.addEventListener('click', function(){ if(state.qty>1){ state.qty--; qn.textContent=state.qty; } });
    qp.addEventListener('click', function(){ if(state.qty<10){ state.qty++; qn.textContent=state.qty; } });
    qctrl.appendChild(qm); qctrl.appendChild(qn); qctrl.appendChild(qp);
    qrow.appendChild(qlbl); qrow.appendChild(qctrl);
    body.appendChild(qrow);
    var d2 = document.createElement('div'); d2.className = 'bv-div'; body.appendChild(d2);
    var atc = document.createElement('button'); atc.type='button'; atc.id='bv-atc';
    atc.textContent='Aggiungi al carrello'; atc.disabled=true;
    atc.addEventListener('click', doATC);
    body.appendChild(atc);
    var lnk = document.createElement('a'); lnk.id='bv-lnk'; lnk.textContent='Vedi prodotto completo →';
    body.appendChild(lnk);
    sh.appendChild(body);
    document.body.appendChild(sh);
    var sy=0;
    sh.addEventListener('touchstart',function(e){sy=e.touches[0].clientY;},{passive:true});
    sh.addEventListener('touchend',function(e){if(e.changedTouches[0].clientY-sy>60)closeSheet();},{passive:true});
  }

  function openSheet(){
    document.getElementById('bv-sh').classList.add('on');
    document.getElementById('bv-bd').classList.add('on');
    document.body.style.overflow='hidden';
    document.body.classList.add('bv-qs-open'); /* nasconde bottom nav */
  }
  function closeSheet(){
    var sh=document.getElementById('bv-sh'),bd=document.getElementById('bv-bd');
    if(sh)sh.classList.remove('on'); if(bd)bd.classList.remove('on');
    document.body.style.overflow='';
    document.body.classList.remove('bv-qs-open'); /* ripristina bottom nav */
  }

  function money(cents){ return '€'+(cents/100).toFixed(2).replace('.',','); }

  function getCardLink(card) {
    var pcl = card.closest('product-card-link');
    if (pcl) {
      var a = pcl.querySelector('a[href*="/products/"]') || pcl.querySelector('a[href]');
      if (a) return a;
    }
    return card.querySelector('a[href*="/products/"]')
      || card.querySelector('a.product-card__link')
      || card.querySelector('a[href]')
      || null;
  }

  function getInlineProduct(card) {
    var raw = card.dataset.bvJson;
    if (!raw) return null;
    try {
      var d = JSON.parse(raw);
      if (!d || !d.opts || !d.vars) return null;
      return {
        options: d.opts,
        variants: d.vars.map(function(v) {
          return { id: v.id, available: v.av, price: v.p, option1: v.o1, option2: v.o2 || null, option3: v.o3 || null };
        })
      };
    } catch(e) { return null; }
  }

  function openCard(card) {
    build();
    state.qty = 1; state.variantId = null;
    document.getElementById('bv-qn').textContent = '1';

    var imgEl = card.querySelector('img[src]');
    var titleEl = card.querySelector('[class*="heading"], h3, h2');
    var priceEl = card.querySelector('[class*="price-item"], [class*="price"]');
    var vendorEl = card.querySelector('[class*="vendor"]');
    var linkEl = getCardLink(card);
    var href = linkEl ? (linkEl.getAttribute('href') || '') : '';
    var hm = href.match(/\/products\/([^?#\/]+)/); var handle = hm ? hm[1] : null;
    var vm = href.match(/[?&]variant=(\d+)/); var vidFromUrl = vm ? parseInt(vm[1],10) : null;

    document.getElementById('bv-img').src = imgEl ? imgEl.src.split('?')[0]+'?width=300' : '';
    document.getElementById('bv-vendor').textContent = vendorEl ? vendorEl.textContent.trim() : '';
    document.getElementById('bv-title').textContent = titleEl ? titleEl.textContent.trim() : '';
    document.getElementById('bv-price').textContent = priceEl ? priceEl.textContent.trim() : '';
    document.getElementById('bv-lnk').href = href || '#';

    setATC(false, 'Seleziona la taglia');
    openSheet();

    var inlineProduct = getInlineProduct(card);
    if (inlineProduct) { processProduct(inlineProduct, vidFromUrl); return; }

    var scriptData = null;
    var roots = [card];
    var pcl = card.closest('product-card-link');
    if (pcl) roots.push(pcl);
    roots.forEach(function(root){
      if (scriptData) return;
      root.querySelectorAll('script[type="application/json"]').forEach(function(s){
        if (scriptData) return;
        try { var d = JSON.parse(s.textContent); if (d && d.variants) scriptData = d; } catch(e){}
      });
    });
    if (scriptData) { processProduct(scriptData, vidFromUrl); return; }

    if (!handle) { return; }
    document.getElementById('bv-opts').innerHTML = '<div style="font-size:12px;color:rgba(0,0,0,.35);padding:4px 0 14px;">Caricamento taglie...</div>';
    fetch('/products/' + handle + '.js')
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if (!p || !document.getElementById('bv-sh').classList.contains('on')) return;
        processProduct(p, vidFromUrl);
      })
      .catch(function(){});
  }

  function processProduct(p, vidFromUrl) {
    var firstV = p.variants[0];
    if (firstV) document.getElementById('bv-price').textContent = money(firstV.price);
    renderVariants(p, vidFromUrl);
    var sel = vidFromUrl
      ? p.variants.filter(function(v){return v.id===vidFromUrl;})[0]
      : p.variants.filter(function(v){return v.available;})[0] || p.variants[0];
    if (sel) { state.variantId = sel.id; setATC(sel.available, sel.available?'Aggiungi al carrello':'Esaurito'); }
  }

  function setATC(enabled, label){
    var b = document.getElementById('bv-atc');
    if (!b) return;
    b.disabled = !enabled; b.textContent = label;
  }

  function renderVariants(product, selectedVid) {
    var container = document.getElementById('bv-opts');
    container.innerHTML = '';
    var opts = product.options;
    if (!opts || !opts.length || (opts.length===1 && opts[0]==='Title')) {
      if (product.variants && product.variants[0]) {
        state.variantId = product.variants[0].id;
        setATC(product.variants[0].available, product.variants[0].available?'Aggiungi al carrello':'Esaurito');
      }
      return;
    }
    opts.forEach(function(name, oi) {
      var g = document.createElement('div'); g.className='bv-og';
      var l = document.createElement('div'); l.className='bv-ol'; l.textContent=name.toUpperCase();
      g.appendChild(l);
      var r = document.createElement('div'); r.className='bv-or';
      var seen=[];
      product.variants.forEach(function(v){
        var val=v['option'+(oi+1)];
        if(!val||seen.indexOf(val)!==-1)return; seen.push(val);
        var p=document.createElement('button'); p.type='button'; p.className='bv-op';
        p.textContent=val; p.dataset.v=val;
        var isSelected = false;
        if(selectedVid){
          var sv=product.variants.filter(function(x){return x.id===selectedVid;})[0];
          if(sv && sv['option'+(oi+1)]===val) isSelected=true;
        } else if(seen.length===1) isSelected=true;
        if(isSelected) p.classList.add('on');
        if(!product.variants.some(function(v2){return v2['option'+(oi+1)]===val&&v2.available;})) p.classList.add('na');
        p.addEventListener('click',function(){
          r.querySelectorAll('.bv-op').forEach(function(x){x.classList.remove('on');});
          p.classList.add('on'); syncVariant(product);
        });
        r.appendChild(p);
      });
      g.appendChild(r); container.appendChild(g);
    });
  }

  function syncVariant(product) {
    var sel=[];
    document.querySelectorAll('#bv-opts .bv-og').forEach(function(g){
      var a=g.querySelector('.bv-op.on'); if(a) sel.push(a.dataset.v);
    });
    var matched=null;
    product.variants.forEach(function(v){
      var opts=[v.option1,v.option2,v.option3].filter(Boolean);
      if(sel.every(function(s,i){return opts[i]===s;})) matched=v;
    });
    if(!matched)return;
    state.variantId=matched.id;
    document.getElementById('bv-price').textContent=money(matched.price);
    setATC(matched.available, matched.available?'Aggiungi al carrello':'Esaurito');
  }

  function doATC(){
    if(!state.variantId)return;
    var btn=document.getElementById('bv-atc');
    btn.disabled=true; btn.textContent='...';
    var drw = document.querySelector('cart-drawer-component');
    var hadAO = drw && drw.hasAttribute('auto-open');
    if (hadAO) drw.removeAttribute('auto-open');
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:state.variantId, quantity:state.qty})
    }).then(function(r){return r.json();}).then(function(d){
      if(d.status&&d.status!==200)throw new Error();
      btn.textContent='✓ Aggiunto';
      document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true}));
      setTimeout(function(){
        if (hadAO && drw) drw.setAttribute('auto-open','');
        closeSheet();
      }, 1500);
    }).catch(function(){
      if (hadAO && drw) drw.setAttribute('auto-open','');
      btn.disabled=false;
      btn.textContent='Aggiungi al carrello';
    });
  }

  var BAG='<svg viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" width="15" height="15"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>';

  function addBtn(card){
    if(card.querySelector('.bv-btn'))return;
    var btn=document.createElement('button');
    btn.type='button'; btn.className='bv-btn'; btn.innerHTML=BAG;
    btn.addEventListener('click',function(e){
      e.stopPropagation(); e.preventDefault();
      card.setAttribute('data-no-navigation','');
      openCard(card);
      setTimeout(function(){card.removeAttribute('data-no-navigation');},3000);
    });
    card.appendChild(btn);
  }

  function addSwipe(card){
    var el=card.closest('product-card-link')||card;
    var sx,sy,axis,moved;
    el.addEventListener('touchstart',function(e){
      if(e.target.closest('.bv-btn'))return;
      sx=e.touches[0].clientX;sy=e.touches[0].clientY;axis=null;moved=false;
    },{passive:true});
    el.addEventListener('touchmove',function(e){
      if(e.target.closest('.bv-btn'))return;
      moved=true;
      if(!axis){var dx=Math.abs(e.touches[0].clientX-sx),dy=Math.abs(e.touches[0].clientY-sy);if(dx>8||dy>8)axis=dx>dy?'x':'y';}
    },{passive:true});
    el.addEventListener('touchend',function(e){
      if(e.target.closest('.bv-btn'))return;
      if(!moved||axis!=='x')return;
      var dx=e.changedTouches[0].clientX-sx;
      if(Math.abs(dx)<60)return;
      card.setAttribute('data-no-navigation','');
      setTimeout(function(){card.removeAttribute('data-no-navigation');},3000);
      if(dx<0){doWishlist(card);}
      else{
        var fl=document.createElement('div');fl.className='bv-sw-f';fl.textContent='Quick shop';
        card.appendChild(fl);setTimeout(function(){if(fl.parentNode)fl.remove();},900);
        setTimeout(function(){openCard(card);},200);
      }
    },{passive:true});
  }

  function doWishlist(card){
    var h=document.createElement('div');h.className='bv-sw-h';h.textContent='♥';
    card.appendChild(h);setTimeout(function(){if(h.parentNode)h.remove();},900);
    var linkEl2 = getCardLink(card);
    var href = linkEl2 ? (linkEl2.getAttribute('href') || '') : '';
    var m=href.match(/\/products\/([^?#\/]+)/);
    if(!m)return;
    var handle=m[1];
    try{
      var items=JSON.parse(localStorage.getItem('bv_wishlist_items')||'[]');
      if(items.some(function(i){return i.handle===handle;}))return;
      var img=card.querySelector('img'),t=card.querySelector('[class*="heading"],[class*="title"],h3,h2'),pr=card.querySelector('[class*="price"]');
      items.push({handle:handle,id:handle,url:'/products/'+handle,image:img?img.src:'',title:t?t.textContent.trim():handle,price:pr?pr.textContent.trim():''});
      localStorage.setItem('bv_wishlist_items',JSON.stringify(items));
      document.dispatchEvent(new CustomEvent('bv:wishlist:update',{bubbles:true}));
    }catch(e){}
  }

  function init(){
    document.querySelectorAll('product-card').forEach(function(card){
      if(card.dataset.bvCc)return;
      card.dataset.bvCc='1';
      addBtn(card); addSwipe(card);
    });
  }

  function boot(){
    init();
    new MutationObserver(function(){init();}).observe(document.body,{childList:true,subtree:true});
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
  else boot();

})();
